<div class="fixed z-[11000] w-full max-w-sm p-4 text-body bg-neutral-primary-soft rounded-base shadow top-5 end-5"
    role="alert" *ngIf="toast">
    <div class="flex items-center">
        <div class="inline-flex items-center justify-center shrink-0 w-7 h-7 {{ toast.iconClass }} rounded">
            <span *ngIf="toast.iconType == 'svg'" [innerHTML]="parseHTML(toast.icon)"></span>
            <span class="sr-only">{{toast.iconLabel}}</span>
        </div>
        <div class="ms-3 text-sm font-normal"> {{ message }} </div>
        <button type="button"
            class="ms-auto flex items-center justify-center text-body bg-transparent box-border font-medium leading-5 rounded text-sm h-8 w-8"
            aria-label="Close" (click)="clearToast()">
            <span class="sr-only">Close</span>
            <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                fill="none" viewBox="0 0 24 24">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M6 18 17.94 6M18 18 6.06 6" />
            </svg>
        </button>
    </div>

    <div class="w-full bg-neutral-quaternary rounded-full h-1 mt-1" *ngIf="showProgressBar">
        <div class="{{toast.progressBarColor}} h-1 rounded-full" [ngStyle]="{width: timebreak + '%'}"></div>
    </div>
</div>
